import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UserDataService } from 'src/app/services/user-data.service';
@Component({
  selector: 'app-tanques',
  templateUrl: './tanques.component.html',
  styleUrls: ['./tanques.component.css']
})
export class TanquesComponent {

  //DATOS
  tanksData: any;
  beersData: any;
  devicesData: any;
  establecimientosData: any;
  tablaData: any [] = [];

  //ERROR
  errorMessage : string = "";

  //TABLA
  datosRecibidos: boolean = false;
  displayedColumns: string[] = ['nombreTanque','dispositivoReference','establecimiento','espacio', 'numero' ,'cerveza', 'capacidad','cliente','operaciones'];
  dataSource :any;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  userDataInfo: any = [];

  //SUBSCRIPCIONES
  private tanksSubscription: Subscription | undefined;
  private beersSubscription: Subscription | undefined;
  private devicesSubscription: Subscription | undefined;
  private establecimientosSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private error429: Error429Service, private userDataService: UserDataService){
    this.userDataInfo = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    if(this.userDataInfo.pro_id != "4"){
      this.displayedColumns = ['nombreTanque','dispositivoReference','establecimiento','espacio', 'numero' ,'cerveza', 'capacidad','operaciones'];
    }
    this.tanksSubscription = this.deviceService.getTanks().subscribe({
      next:resp =>{
        this.tanksData = resp;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.beersSubscription = this.deviceService.getBeerType().subscribe({
          next:resp =>{
            this.beersData = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{
            this.establecimientosSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
              next:resp =>{
                this.establecimientosData = resp;
              },error:err =>{
                if (err.status == 429) {
                  this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                  this.recargarPaginaDespuesDeTiempo();
                } else {
                  this.errorMessage = err.error.message;
                }
              }, complete:()=>{
                this.devicesSubscription = this.deviceService.getDevicesDataNew().subscribe({
                  next:resp =>{
                    this.devicesData = resp;
                  },error:err =>{
                    if (err.status == 429) {
                      this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                      this.recargarPaginaDespuesDeTiempo();
                    } else {
                      this.errorMessage = err.error.message;
                    }
                  }, complete:()=>{
                    console.log(this.tanksData);
                    for(let i=0; i<this.tanksData.length; i++){
                      const tankData: any = {
                        id: this.tanksData[i].id,
                        est_id: this.obtenerIDEstablecimiento(this.tanksData[i].device_id),
                        dev_id: this.tanksData[i].device_id,
                        nombreTanque: this.tanksData[i].external_id,
                        dispositivoReference: this.obtenerNombreDispositivo(this.tanksData[i].device_id) + ' ('+ this.obtenerReferenciaDispositivo(this.tanksData[i].device_id) +')',
                        espacio: this.tanksData[i].slot,
                        numero: this.tanksData[i].custom_num,
                        cerveza: this.obtenerNombreCerveza(this.tanksData[i].beer_type_id),
                        establecimiento: this.obtenerNombreEstablecimiento(this.tanksData[i].device_id),
                        cliente: this.tanksData[i].cliente.razon_social,
                        capacidad: this.tanksData[i].capacity,
                      }
                      this.tablaData.push(tankData);
                    }
                    this.dataSource = new MatTableDataSource(this.tablaData); 
                    //Filtrado personalizado para que no tenga en cuenta el id del tanque.
                    this.dataSource.filterPredicate = (data: any, filter: string) => {
                      const dataStr = this.displayedColumns
                        .filter(key => key !== 'id' && key !== 'est_id' && key !== 'dev_id')
                        .map(key => data[key])
                        .join('')
                        .toLowerCase();
                  
                      return dataStr.includes(filter);
                    };
                    setTimeout(() => {
                      this.dataSource.sort = this.sort;
                      this.dataSource.paginator = this.paginator;
                    },0)
                    this.datosRecibidos = true;
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  obtenerNombreCerveza(id: number): string {
    const cerveza = this.beersData.find((beer:any) => beer && beer.id === id);
    return cerveza ? cerveza.name : 'Cerveza no encontrada';
  }

  obtenerNombreDispositivo(id: number): string {
    const device = this.devicesData.find((device:any) => device && device.id === id);
    return device ? device.dev_label : 'Dispositivo no encontrado';
  }

  obtenerReferenciaDispositivo(id: number): string {
    const device = this.devicesData.find((device:any) => device && device.id === id);
    return device ? device.dev_reference : 'Dispositivo no encontrado';
  }

  obtenerNombreEstablecimiento(id: number): string{
    const device = this.devicesData.find((device:any) => device && device.id === id);
    if(device != undefined){
      const establecimiento = this.establecimientosData.find((establecimiento:any) => establecimiento && establecimiento.id === device.dev_est_id);
      return establecimiento ? establecimiento.est_name : 'Establecimiento no encontrado';
    } else {
      return 'No encontrado';
    }
  }

  obtenerIDEstablecimiento(id: number): string{
    const device = this.devicesData.find((device:any) => device && device.id === id);
    if(device != undefined){
      const establecimiento = this.establecimientosData.find((establecimiento:any) => establecimiento && establecimiento.id === device.dev_est_id);
      return establecimiento ? establecimiento.id : 'Establecimiento no encontrado';
    } else {
      return 'No encontrado';
    }
  }

  ngOnDestroy(): void {
    if (this.tanksSubscription) {
      this.tanksSubscription.unsubscribe();
    } 
    if (this.beersSubscription) {
      this.beersSubscription.unsubscribe();
    } 
    if (this.devicesSubscription) {
      this.devicesSubscription.unsubscribe();
    } 
    if (this.establecimientosSubscription) {
      this.establecimientosSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  descargarExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Tanque', key: 'nombreTanque', width: 20 },
      { header: 'Establecimiento', key: 'establecimiento', width: 20 },
      { header: 'Referencia del dispositivo', key: 'dispositivoReference', width: 20 },
      { header: 'Posición en dispositivo', key: 'espacio', width: 10 },
      { header: 'Nº de tanque', key: 'numero', width: 30 },
      { header: 'Cerveza', key: 'cerveza', width: 25 },
      { header: 'Capacidad (L)', key: 'capacidad', width: 15 },
      { header: 'Cliente', key: 'cliente', width: 25 },
    ];

    this.tablaData.forEach(tanque => {
      const row = worksheet.addRow(tanque);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado tanques DataBeer.xlsx');
    });
  }

}
